import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchAnalytics } from "../Actions";
import WeeklyRiskTrend from "./graphs/WeeklyRiskTrend";
import audioImg from "../Assets/images/dashboard/audio.svg";
import assessmentsImg from "../Assets/images/dashboard/doctor.svg";
import virusImg from "../Assets/images/dashboard/virus.svg";
import { ShimmerThumbnail } from "react-shimmer-effects";
import * as moment from "moment";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import HomePage from "./HomePage";
import Popup from "./Popup";


const Dashboard = (props) => {
  let date = moment(new Date());

  // const [endDate, setEndDate] = useState(
  //   new Date(date.add(1, "day").valueOf())
  // );
  // const [startDate, setStartDate] = useState(
  //   new Date(date.subtract(1, "month").valueOf())
  // );

  const [dateRange, setDateRange] = useState({
    startDate: new Date(date.subtract(1, "week").valueOf()),
    endDate: new Date(date.add(7, "day").valueOf()),
  });

  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dates1, setDates1] = useState("");
  const [dates2, setDates2] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    setShowPopup(true);
  }, []);

  useEffect(() => {
    const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
    const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");

    if (dateRange.endDate !== null && dateRange.startDate !== null) {
      setLoading(true);

      props.fetchAnalytics(endDate1, startDate1).then(() => setLoading(false));

      setDates1(startDate1.toLocaleString());
      setDates2(endDate1.toLocaleString());
    } else {
      setLoading(true);
      props.fetchAnalytics().then(() => setLoading(false));
    }
  }, [dateRange.startDate, dateRange.endDate]);

  const [oneWeekPressed, setOneWeekPressed] = useState(false);
  const [twoWeekPressed, setTwoWeekPressed] = useState(false);
  const [oneMonthPressed, setOneMonthPressed] = useState(true);
  const [threeMonthPressed, setthreeMonthPressed] = useState(false);
  const [sixMonthPressed, setSixMonthPressed] = useState(false);

  const oneWeekHandler = () => {
    setOneWeekPressed(true);
    setTwoWeekPressed(false);
    setOneMonthPressed(false);
    setthreeMonthPressed(false);
    setSixMonthPressed(false);

    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    // setStartDate(new Date(newStartdate.subtract(7, "day").valueOf()));
    // setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
    setDateRange({
      startDate: new Date(newStartdate.subtract(7, "day").valueOf()),
      endDate: new Date(newEnddate.add(1, "day").valueOf()),
    });
  };

  const oneMonthHandler = () => {
    setOneWeekPressed(false);
    setTwoWeekPressed(false);
    setOneMonthPressed(true);
    setthreeMonthPressed(false);
    setSixMonthPressed(false);

    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    // setStartDate(new Date(newStartdate.subtract(1, "month").valueOf()));
    // setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
    setDateRange({
      startDate: new Date(newStartdate.subtract(1, "month").valueOf()),
      endDate: new Date(newEnddate.add(1, "day").valueOf()),
    });
  };

  const oneDayHandler = () => {
    setSelectedOption("1day");
    const today = moment().startOf("day").toDate();
    // setStartDate(today); // Set start date to today
    // setEndDate(today); // Set end date to today
    setDateRange({ startDate: today, endDate: today });
  };
  const oneYearHandler = () => {
    setSelectedOption("1year");
    const startDate = moment().subtract(1, "year").toDate();
    const endDate = moment().toDate();
    // setStartDate(startDate); // Set start date 1 year ago
    // setEndDate(endDate); // Set end date to end of this year
    setDateRange({ startDate: startDate, endDate: endDate });
  };

  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 1000;
  React.useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  const dividedResult =
    props.analytics.assessmentsCount !== 0 &&
    props.analytics.patientsAssessedCount !== 0
      ? props.analytics.assessmentsCount / props.analytics.patientsAssessedCount
      : 0;
  const roundedResult = dividedResult !== 0 ? Math.ceil(dividedResult) : 0;

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    if (value === "1week") {
      oneWeekHandler();
      setShowDatePicker(false);
    } else if (value === "1day") {
      oneDayHandler();
      setShowDatePicker(false);
    } else if (value === "1month") {
      oneMonthHandler();
      setShowDatePicker(false);
    } else if (value === "1year") {
      oneYearHandler();
      setShowDatePicker(false);
    } else if (value === "custom") {
      setShowDatePicker(true);
    }
  };

  const handleRangeSelected = (args) => {
    const startDate1 = args.value[0];
    const endDate1 = args.value[1];

    const startDate2 = moment(startDate1).format("YYYY-MM-DD");
    const endDate2 = moment(endDate1).format("YYYY-MM-DD");

    setDateRange({ startDate: startDate2, endDate: endDate2 });

    setSelectedOption("");
  };

  const handleDateRangePickerRef = (ref) => {
    if (ref && selectedOption === "custom") {
      ref.show();
    }
  };



  if (width > breakpoint) {
    if (loading) {
      if (localStorage.rpm === "rpm") {
        return (
          <>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  marginLeft: "15px",
                  marginBottom: "0px",
                  marginTop: "40px",
                  height: "100%",
                  width: "23%",
                }}
              >
                <ShimmerThumbnail height={660} className="m-0" rounded />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "35px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "17px",
                    marginLeft: "10px",
                    marginBottom: "15px",
                    marginTop: "5px",
                  }}
                >
                  <ShimmerThumbnail
                    height={230}
                    width={320}
                    className="m-0"
                    rounded
                  />
                  <ShimmerThumbnail
                    height={230}
                    width={320}
                    className="m-0"
                    rounded
                  />
                  {/* <ShimmerThumbnail
                    height={230}
                    width={320}
                    className="m-0"
                    rounded
                  /> */}
                </div>
                <div
                  style={{ display: "flex", gap: "17px", marginLeft: "10px" }}
                >
                  <ShimmerThumbnail
                    height={400}
                    width={1005}
                    className="m-0"
                    rounded
                  />
                </div>
              </div>
            </div>
          </>
        );
      } else {
        return (
          <>
            <div style={{ marginTop: "20px", marginLeft: "10px" }}>
              <ShimmerThumbnail
                height={40}
                width={400}
                className="m-0"
                rounded
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "20px",
                marginLeft: "10px",
                marginBottom: "15px",
              }}
            >
              <ShimmerThumbnail
                height={230}
                width={400}
                className="m-0"
                rounded
              />
              <ShimmerThumbnail
                height={230}
                width={400}
                className="m-0"
                rounded
              />
              {/* <ShimmerThumbnail
                height={230}
                width={400}
                className="m-0"
                rounded
              /> */}
            </div>
            <div style={{ display: "flex", gap: "17px", marginLeft: "10px" }}>
              <ShimmerThumbnail
                height={500}
                width={1250}
                className="m-0"
                rounded
              />
            </div>
          </>
        );
      }
    } else
      return (
        <>
          <div
            className="dashboard"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {localStorage.rpm === "rpm" && <HomePage />}
            <div className="dashboard__content">
              <div className="dateSelection">
                <select
                  className="selectDate"
                  id="duration"
                  value={selectedOption}
                  onChange={handleChange}
                >
                  <option>Date Range</option>
                  <option value="1day">1 Day</option>
                  <option value="1week">1 Week</option>
                  <option value="1month">1 Month</option>
                  <option value="1year">1 Year</option>
                  <option value="custom" key="">
                    Custom
                  </option>
                </select>
                {showDatePicker && (
                  <div className="dateRangePicker">
                    <DateRangePickerComponent
                      id="daterangepicker"
                      placeholder="Select a range"
                      startDate={dateRange.startDate}
                      endDate={dateRange.endDate}
                      showClearButton={false}
                      onChange={handleRangeSelected}
                      ref={(ref) => handleDateRangePickerRef(ref)}
                      format="dd/MM/yyyy"
                    />
                  </div>
                )}
                <div className="dates-container">
                  <p className="dates">
                    {moment(dates1).format("DD-MM-YYYY")}{" "}
                  </p>
                  <p className="dates">to</p>
                  <p className="dates">
                    {moment(dates2).format("DD-MM-YYYY")}{" "}
                  </p>
                </div>
              </div>
              <div className="dashboard__summary">
                <div className="card2">
                  <div className="card2--info__content">
                    <p className="card2--info__title">Total Patients Scanned</p>
                    <img
                      style={{ height: "35px", margin: "50px 0 15px 0" }}
                      src={audioImg}
                      alt="patients"
                    />
                    <p className="card2--info__count">
                      {props.analytics.patientsCount}
                    </p>
                  </div>
                  <p
                    className="card2--info__description"
                    style={{ color: "#46360999" }}
                  >
                    Total number of patients assessed in the selected time
                    period.
                  </p>
                </div>
                <div className="card2 card2--high-risk">
                  <div className="card2--info__content">
                    <p className="card2--info__title">Patients with High LHI</p>
                    <img
                      src={virusImg}
                      alt="high risk"
                      style={{ marginTop: "30px" }}
                    />
                    <p className="card2--info__count">
                      {props.analytics.highRiskCount}
                    </p>
                  </div>
                  <p
                    className="card2--info__description"
                    style={{ color: "#ff536899" }}
                  >
                    Number of patients found with high LHI in the selected time
                    period.
                  </p>
                </div>
                {localStorage.longitudinal_study === "true" && (
                  <div className="card2 card2--assessments">
                    <div className="card2--info__content">
                      <p className="card2--info__title">
                        Assessments per Patient
                      </p>
                      <img
                        src={assessmentsImg}
                        alt="assessments"
                        style={{ marginTop: "30px" }}
                      />
                      <p className="card2--info__count">{roundedResult}</p>
                    </div>
                    <p
                      className="card2--info__description"
                      style={{ color: "#46360999" }}
                    >
                      Average number of assessments per patient in the selected
                      time period.
                    </p>
                  </div>
                )}
              </div>
              {localStorage.validation != "true" ? (
                <div className="dashboard__analytics">
                  <WeeklyRiskTrend />
                  {loading ? (
                    <></>
                  ) : (
                    <div>
                      <Popup
                        message="Hi, I am here to assist you"
                        onClose={closePopup}
                        show={showPopup}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div className="dashboard__analytics">
                  <WeeklyRiskTrend />
                  {loading ? (
                    <></>
                  ) : (
                    <div>
                      <Popup
                        message="Hi, I am here to assist you"
                        onClose={closePopup}
                        show={showPopup}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </>
      );
  } else {
    if (loading) {
      if (localStorage.rpm === "rpm") {
        return (
          <>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  marginLeft: "15px",
                  marginBottom: "0px",
                  marginTop: "40px",
                  width: "24%",
                }}
              >
                <ShimmerThumbnail height={660} className="m-0" rounded />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "35px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "17px",
                    marginLeft: "10px",
                    marginBottom: "15px",
                    marginTop: "5px",
                  }}
                >
                  <ShimmerThumbnail
                    height={230}
                    width={320}
                    className="m-0"
                    rounded
                  />
                  <ShimmerThumbnail
                    height={230}
                    width={320}
                    className="m-0"
                    rounded
                  />
                  {/* <ShimmerThumbnail
                    height={230}
                    width={320}
                    className="m-0"
                    rounded
                  /> */}
                </div>
                <div
                  style={{ display: "flex", gap: "17px", marginLeft: "10px" }}
                >
                  <ShimmerThumbnail
                    height={400}
                    width={1005}
                    className="m-0"
                    rounded
                  />
                </div>
              </div>
            </div>
          </>
        );
      } else {
        return (
          <>
            <div
              style={{
                display: "flex",
                gap: "17px",
                marginLeft: "10px",
                marginBottom: "15px",
              }}
            >
              <ShimmerThumbnail
                height={230}
                width={400}
                className="m-0"
                rounded
              />
              <ShimmerThumbnail
                height={230}
                width={400}
                className="m-0"
                rounded
              />
              {/* <ShimmerThumbnail
                height={230}
                width={400}
                className="m-0"
                rounded
              /> */}
            </div>
            <div style={{ display: "flex", gap: "17px", marginLeft: "10px" }}>
              <ShimmerThumbnail
                height={500}
                width={1250}
                className="m-0"
                rounded
              />
            </div>
          </>
        );
      }
    } else
      return (
        <>
          <div className="dashboard">
            {localStorage.rpm === "rpm" && <HomePage />}
            <div className="dashboard__content">
              <div className="dashboard__summary">
                <div className="card2">
                  <div className="card2--info__content">
                    <p className="card2--info__title">Total Patients Scanned</p>
                    <img src={audioImg} alt="patients" />
                    <p className="card2--info__count">
                      {props.analytics.records.length}
                    </p>
                  </div>
                  <p
                    className="card2--info__description"
                    style={{ color: "#46360999" }}
                  >
                    Total number of patients registered in the selected location
                  </p>
                </div>
                <div className="card2 card2--high-risk">
                  <div className="card2--info__content">
                    <p className="card2--info__title">
                      Patients with High LHI (7-10)
                    </p>
                    <img src={virusImg} alt="high risk" />
                    <p className="card2--info__count">
                      {props.analytics.highRiskCount}
                    </p>
                  </div>
                  <p
                    className="card2--info__description"
                    style={{ color: "#ff536899" }}
                  >
                    Number of patients who have been found with high LHI
                  </p>
                </div>
                <div className="card2 card2--assessments">
                  <div className="card2--info__content">
                    <p className="card2--info__title">
                      Assessments per Patient
                    </p>
                    <img src={assessmentsImg} alt="assessments" />
                    <p className="card2--info__count">
                      {props.analytics.records.length !== 0
                        ? parseFloat(props.analytics.assessmentsCount) /
                          parseFloat(props.analytics.records.length)
                        : 0}
                    </p>
                  </div>
                  <p
                    className="card2--info__description"
                    style={{ color: "#1ad94799" }}
                  >
                    Number of assessments divided by the total Number of
                    patients scanned
                  </p>
                </div>
              </div>
              <div className="dashboard__analytics">
                <WeeklyRiskTrend />
              </div>
              {/* {loading ? (
                <></>
              ) : (
                <Popup
                  message="Hi, I am here to assist you"
                  onClose={closePopup}
                  show={showPopup}
                />
              )} */}
            </div>
          </div>
        </>
      );
  }
};

const mapStateToProps = (state) => ({
  analytics: state.analytics,
});

export default connect(mapStateToProps, { fetchAnalytics })(Dashboard);
